EMRAdmin.service("CommonAuthenticateService", ['ModalPopupService', function (ModalPopupService) {


    /**
     * @type {Object<string | number, Object>}
     * @type {Object} authenticationStore
    */

    //this is to get the otpCategory type and 
    //the authorisedDuration and authorised time of that particular OtpCategory type
    var authenticationStore = {}

    /**
     * Function to check if user is authenticated 
     * @param {number} otpCategoryType 
     * @returns {boolean} Returns true is authenticated otherwise false
     */
    function isUserAuthenticated(otpCategoryType) {

        // if the application type is ehr and practice id is 405 and logged user id is 5 then 
        // consider user as authenticate user allowing access
        //modified by Swaraj B on 13 Jul, 2021 ; added another user (userid=7)
        if (EMRPracticeModel && EMRPracticeModel.ApplicationType == 1 &&
            EMRPracticeModel.PracticeID == 405 && (EMRPracticeModel.LoggedUserID == 5 || EMRPracticeModel.LoggedUserID == 7))
            return true;
        if (EMRPracticeModel && otpCategoryType == 106 && !([999].includes(EMRPracticeModel.PracticeID)))
            return true;
        var authenticationInfo
        //this variable is to get the duration, authenticated time
        authenticationInfo = authenticationStore[otpCategoryType]
        // if the otp category is not in 
        if (!(otpCategoryType in authenticationStore) || !authenticationInfo.authenticationDuration) {
            return false
        }


        // if the maximum authentication time is exceeded returning false
        return DateDiffInMins(new Date(), authenticationInfo.authenticatedDateTime) < authenticationInfo.authenticationDuration
    }

    /**
     * Function to open authentication popup
     * @returns {Promise} returns a promise which has authentication info
     */
    function showAuthenticationPopup(navigationDetails) {
        //calling Authentication Popup
        return ModalPopupService.OpenPopup(GetEMRPageURLByIndex(2476), navigationDetails, 'modal-440px').then(function (result) {
            if (!result || result == 'cancel' || !result.data || !result.data.EmailId) {
                if (window.location.href.indexOf("localhost") > 0 && navigationDetails && navigationDetails.OTPCategoryType == 1) {
                    return result = "test";
                }
                throw new Error('User not Authenticated')
            }
            return result;
        });
    }
    //this func is used to get the stroed user details
    function getAuthorizsedUserDetailsBasedOnCateoryType(OTPCategoryType) {
        return OTPCategoryType in authenticationStore ? authenticationStore[OTPCategoryType] : {};
    }
    /**
     * Decorates a function with Authentication Popup 
     * @param {Function} fn 
     */
    function authenticationDecorator(fn, navigationDetails) {
        return function () {
            var args = arguments
            /**
             * this condition added to get EF template id
             * 1 : Edit Iframe Forms authentication category
             * 66 : Edit Div Forms Authentication category
             */
            if ([1, 66].includes(navigationDetails.OTPCategoryType) && typeof (navigationDetails.getEFTemplateID) == 'function' && typeof(navigationDetails.getEFTemplateName) == 'function'){
                navigationDetails.DocumentTemplateID = navigationDetails.getEFTemplateID();
                navigationDetails.DocumentTemplateName = navigationDetails.getEFTemplateName();
            }


            if (hasValue(navigationDetails) && navigationDetails.noNeedAuthentication)
                return fn.apply(undefined, args);
            
            if (hasValue(navigationDetails) && isUserAuthenticated(navigationDetails.OTPCategoryType)) {
                return fn.apply(undefined, args)
            }
            return showAuthenticationPopup(navigationDetails).then(function (response) {
                authenticationStore[navigationDetails.OTPCategoryType] = Object.assign({}, navigationDetails, { authenticatedDateTime: new Date(), EmailId: (response && response.data && response.data.EmailId) || "" })

                return fn.apply(undefined, args)
            })
        }
    }

    Object.assign(this, {
        authenticationDecorator: authenticationDecorator,
        getAuthorizsedUserDetailsBasedOnCateoryType: getAuthorizsedUserDetailsBasedOnCateoryType
    });

}]);